import { getApiConfig } from '@foundation/apis/ApiConfig';
import { parseInstruments } from '@foundation/apis/payments/helpers/parseInstruments';
import { ApiPaymentInstrument } from '@foundation/apis/payments/types/ApiPaymentInstrument';

import { handleApiResponse } from './helpers/handleApiResponse';

type GetPaymentInstrumentsOptions = {
  readonly tpId: string;
  readonly bearerToken: string;
  readonly legalEntityNumber?: number;
};

export async function getPaymentInstruments(
  options: GetPaymentInstrumentsOptions,
) {
  const { paymentsApiUrl } = getApiConfig();
  const { tpId, bearerToken, legalEntityNumber } = options;

  const searchParams = new URLSearchParams({
    customerNumber: tpId,
  });

  if (legalEntityNumber) {
    searchParams.append('legalEntityNumber', legalEntityNumber.toString());
  }

  const response = await fetch(
    `${paymentsApiUrl}/paymentinstruments?${searchParams.toString()}`,
    {
      method: 'GET',
      headers: {
        'content-type': 'application/json',
        authorization: `Bearer ${bearerToken}`,
      },
    },
  );

  const instruments = await handleApiResponse<ApiPaymentInstrument[]>(
    response,
    'Failed to fetch payment instruments',
  );
  return parseInstruments(instruments);
}
